<div class="page" [ngClass]="{'activeCmpt' : !modoEstandar}">

  <div class="header">

    <div class="titleClock">
      <h1 class="text-nowrap">DESPACHADOR</h1>

      <div class="reloj">{{ horaActual }}</div>

      <div class="indic" [ngClass]="{'active' : indicadores}">
        <div class="ico d-flex d-md-none"><img src="assets/img/icoIndicadores.svg"></div>
        <div class="label d-none d-md-block">INDICADORES</div>
        <div class="switch" (click)="indicadores = !indicadores">
          <span></span>
        </div>
      </div>

      <div class="modo" (click)="modoEstandar = !modoEstandar" [ngClass]="{'activeCmpt' : !modoEstandar}">
        <div class="but">ESTANDAR</div>
        <div class="but">COMPACTO</div>
      </div>
    </div>

    <div class="btnSync">
      <div class="ico" (click)="reload()" [tooltip]="'Recargar datos'">
        <img src="assets/img/icoRefresh.svg" alt="">
      </div>
      <ng-select class="selectNg" [items]="recargas" bindLabel="label" bindValue="value" [(ngModel)]="recarga"
        placeholder="RECARGAR CADA..." (change)="calcularTime()" (clear)="recarga = 0; calcularTime()">
      </ng-select>
      <div class="barra" *ngIf="recarga != 0">
        <progressbar [max]="recarga/1000" [value]="contador/1000" [animate]="true" [striped]="true">
        </progressbar>
      </div>
    </div>

    <button *ngIf="tienePermisoCambiarSucursalMovil()" class="btn btnChangeBus" (click)="cambiarSucursalMovil()" [tooltip]="'Cambiar sucursal de móvil'" placement="bottom" container="body">
      <img src="assets/img/icoCambiarBus.svg">
    </button>

    <div class="terminal" [tooltip]="sucursalesSelectedNombresLargos">
      <p><strong>TERMINAL:</strong> {{sucursalesSelectedNombres}}</p>
      <button class="btn btnBlack" (click)="openModalCambiarSucursal()">CAMBIAR</button>
    </div>

  </div>

  <div class="dobleBox">

    <div class="boxL" [ngClass]="{'sinInd' : !indicadores}">

      <div class="indicadores">
        <div class="contBoxes">
          <div *ngFor="let kpi of kpis" class="box" [ngClass]="{'active': kpiSelected?.codigo == kpi.codigo}"
            [style.background-color]="kpi.colorFondo" (click)="onKpiClick(kpi)" [tooltip]="kpi.descripcion"
            placement="bottom" container="body">
            <span [ngStyle]="{'color': kpi.colorLetra}">{{ kpi.tituloPantalla }}</span>
            <h1 [ngStyle]="{'color': kpi.colorLetra}">{{ kpi.valor }}</h1>
          </div>
        </div>
      </div>

      <div class="boxWhite">

        <div class="headBox">
          <div class="filtros">
            <div class="buscar itemForm">
              <input type="search" class="form-control" placeholder="Buscar..." [ngModel]="searchText"
                (ngModelChange)="onSearchChange($event)">
            </div>

            <div class="select itemForm d-lg-block d-none" [tooltip]="getServiciosSentidosSeleccionados()">
              <ng-select class="select select-width" placeholder="Servicio/Sentido"
                [(ngModel)]="servicioSentidoSeleccionado" (change)="onServicioSentidoChange()"
                [items]="serviciosSentidos" bindLabel="label" bindValue="value" [multiple]="true" appendTo="body"
                [closeOnSelect]="false">
                <ng-template ng-multi-label-tmp let-items="items">
                  <span style="display:block; font-size: 13px; top: 7px;color: var(--black)" class="ng-placeholder"
                    *ngIf="items.length > 1">{{items.length}} Seleccionados</span>
                  <span style="display:block; font-size: 13px; top: 7px; color: var(--black)" class="ng-placeholder"
                    *ngIf="items.length == 1">{{items[0].label}}</span>
                </ng-template>
              </ng-select>
            </div>
          </div>

          <!--
          <ng-select class="select select-width" placeholder="Servicio" [(ngModel)]="servicioSeleccionado"
          (change)="changeServicioSeleccionado()" [multiple]="true" appendTo="body">
          <ng-template ng-multi-label-tmp let-items="items">
            <span style="display:block; font-size: 13px; top: 7px;color: var(--black)" class="ng-placeholder"
              *ngIf="items.length > 1">{{items.length}} Seleccionados</span>
            <span style="display:block; font-size: 13px; top: 7px; color: var(--black)" class="ng-placeholder"
              *ngIf="items.length == 1">{{ESTADOS_GESTION_CONDUCTOR[items[0]]}}</span>
          </ng-template>

          <ng-option *ngFor="let key of objectKeys(ESTADOS_GESTION_CONDUCTOR)" [value]="key"
            [disabled]="cantidadEstadoConductor[key] === 0">
            {{ESTADOS_GESTION_CONDUCTOR[key]}}
          </ng-option>
        </ng-select>
          -->
          <!--<button class="btn btnOrange" (click)="openViajeN()">CREAR VIAJE N</button>-->
          <button *ngIf="tienePermisoCrearViaje()" class="btn btnOrange" (click)="crearViajeV2()">CREAR VIAJE</button>

        </div>

        <div class="tableResp" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="1000"
          (scrolled)="onScroll()" [scrollWindow]="false" [alwaysCallback]="false"
          [infiniteScrollDisabled]="desactivarInfiniteScroll">
          <table class="table">

            <thead>
              <tr>
                <th (click)="onSort('id')" style="cursor: pointer;" [tooltip]="'ID del viaje'" placement="bottom" container="body">
                  ID
                  <span *ngIf="orderBy === 'id'" [innerHTML]="orderAsc ? '&#9650;' : '&#9660;'"></span>
                </th>
                <th (click)="onSort('fechahoraInicio')" [tooltip]="'Hora de inicio del viaje'" placement="bottom" container="body">
                  INICIO
                  <span *ngIf="orderBy === 'fechahoraInicio'" [innerHTML]="orderAsc ? '&#9650;' : '&#9660;'"></span>
                </th>
                <th (click)="onSort('servicio')" style="cursor: pointer;" [tooltip]="'Servicio'" placement="bottom" container="body">
                  SERVICIO
                  <span *ngIf="orderBy === 'servicio'" [innerHTML]="orderAsc ? '&#9650;' : '&#9660;'"></span>
                </th>
                <th (click)="onSort('sentido')" style="cursor: pointer;" [tooltip]="'Sentido'" placement="bottom" container="body">
                  SENTIDO
                  <span *ngIf="orderBy === 'sentido'" [innerHTML]="orderAsc ? '&#9650;' : '&#9660;'"></span>
                </th>
                <th (click)="onSort('fechahorasalida')" style="cursor: pointer;" [tooltip]="'Hora de salida'" placement="bottom" container="body">
                  SALIDA
                  <span *ngIf="orderBy === 'fechahorasalida'" [innerHTML]="orderAsc ? '&#9650;' : '&#9660;'"></span>
                </th>
                <th (click)="onSort('patente')" style="cursor: pointer;" [tooltip]="'Móvil asignado'" placement="bottom" container="body">
                  MOVIL
                  <span *ngIf="orderBy === 'patente'" [innerHTML]="orderAsc ? '&#9650;' : '&#9660;'"></span>
                </th>
                <th (click)="onSort('visibleId')" style="cursor: pointer;" [tooltip]="'Conductor asignado'" placement="bottom" container="body">
                  CONDUCTOR
                  <span *ngIf="orderBy === 'visibleId'" [innerHTML]="orderAsc ? '&#9650;' : '&#9660;'"></span>
                </th>
                <th (click)="onSort('estado')" style="cursor: pointer;" [tooltip]="'Estado del viaje'" placement="bottom" container="body">
                  ESTADO
                  <span *ngIf="orderBy === 'estado'" [innerHTML]="orderAsc ? '&#9650;' : '&#9660;'"></span>
                </th>
                <th [tooltip]="'Acciones del viaje'" placement="bottom" container="body">ACCIÓN</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let viaje of viajes"
                [ngClass]="{'selected-row': viaje.uuid === selectedViaje?.uuid, 'bgRed': isViajeAtrasado(viaje)}">
                <td (click)="verDetalleViaje(viaje)">{{ viaje.id}}</td>
                <td (click)="verDetalleViaje(viaje)">{{ viaje.fechahoraInicio | date:'HH:mm' }}</td>
                <td (click)="verDetalleViaje(viaje)"
                  [tooltip]="viaje.sondaServicioSentido ? viaje.sondaServicioSentido.split('_').join(' ') : null">
                  <div class="badge"
                    [ngClass]="'sonda-' + (viaje.sondaServicioSentido || 'NO_CALCULADO').toLowerCase().replace('_', '-')">
                    {{ viaje.servicio }}
                  </div>
                </td>
                <td (click)="verDetalleViaje(viaje)">
                  <div class="badge"
                    [ngClass]="'sonda-' + (viaje.sondaServicioSentido || 'NO_CALCULADO').toLowerCase().replace('_', '-')">
                    {{(viaje.marcaSentido) ? viaje.marcaSentido : ''}} {{ getSentido(viaje)}}
                  </div>
                </td>
                <td (click)="verDetalleViaje(viaje)">{{ viaje.fechahorasalida | date:'HH:mm' }}</td>
                <td (click)="verMoviles(viaje)">
                  <div class="badge" [ngClass]="{
                       'badge-sin-asignar': !viaje.movil?.patente,
                       'badge-asignado': viaje.movil?.patente && !viaje.confirmado,
                       'badge-confirmado': viaje.movil?.patente && viaje.confirmado
                     }">
                    {{ viaje.movil?.patente || ('S/A' + (viaje.tipoMovilRequerido ? ' (' + viaje.tipoMovilRequerido + ')' : '')) }}
                  </div>
                </td>
                <td (click)="verConductores(viaje)">
                  <div class="badge" [ngClass]="{
                       'badge-sin-asignar': !viaje.conductor?.visibleId,
                       'badge-asignado': viaje.conductor?.visibleId && !viaje.confirmado,
                       'badge-confirmado': viaje.conductor?.visibleId && viaje.confirmado
                     }"
                    [tooltip]="viaje.conductor?.visibleId ? (viaje.conductor.nombres + ' ' + viaje.conductor.apellidoPaterno + ' / ' + viaje.conductor.estado) : null">
                    {{ viaje.conductor?.visibleId || ('S/A ' + getCodigoSucursalSugerida(viaje)) }} </div>
                </td>
                <td (click)="verDetalleViaje(viaje)">{{ viaje.estado }}</td>
                <td>
                  <div class="btns">
                    <span *ngIf="tienePermisoIniciarViaje()" [tooltip]="'Iniciar viaje'">
                      <button class="btn btnIniciarViaje" [disabled]="noSePuedeIniciar(viaje)"
                        [ngClass]="{'disabled': noSePuedeIniciar(viaje)}"
                        (click)="!noSePuedeIniciar(viaje) && iniciarViaje(viaje)"><img
                          src="assets/img/icoInicarViaje.svg" alt=""></button>
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>

          </table>
        </div>

      </div>

    </div>

    <div class="boxR">

      <div class="boxWhite" *ngIf="!componenteSeleccionado">
        <div class="sinAccion">
          <img src="assets/img/imgSinAccion.png" class="img-fluid">
          <p>POR FAVOR SELECCIONE EN LA TABLA</p>
        </div>
      </div>

      <app-conductor *ngIf="componenteSeleccionado === 'conductor'" (viewChange)="onViewChange($event)"></app-conductor>

      <app-bus *ngIf="componenteSeleccionado === 'bus'" (viewChange)="onViewChange($event)"></app-bus>

      <app-viaje *ngIf="componenteSeleccionado === 'viaje'" (viewChange)="onViewChange($event)"></app-viaje>

    </div>

  </div>

</div>